import { svg } from 'lit';

const symbol = svg`<svg width="17" height="17" viewBox="0 0 320 512" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48 64C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48h-32z" stroke="#F5F5F5"/></svg>`;

export { symbol as default };
